import { memo } from "react";
import * as Styled from "./style";
import { ProductSkeleton } from "~/components/blocks/product/skeleton";

export const DetailProductSkeleton = memo(() => {
  return (
    <Styled.DivMaxWidth>
      <Styled.DivSkeletonRoot>
        <Styled.SampleAssetSkeleton type="square" width="100%" />
        <ProductSkeleton />
      </Styled.DivSkeletonRoot>
    </Styled.DivMaxWidth>
  );
});

DetailProductSkeleton.displayName = "DetailProductSkeleton";
